// requires vue-media-queries be injected into the Vue app to use

// based on bootstrap 3 breakpoint pixel widths
const sm = 768
const md = 992
const lg = 1200

export default {
  computed: {
    isMobile () {
      return this.$resize && this.$mq.below(sm - 1)
    },
    isTablet () {
      return this.$resize && (this.$mq.above(sm) && this.$mq.below(md))
    },
    isTabletOrLower () {
      return this.isMobile || this.isTablet
    },
    isTabletOrHigher () {
      return this.isTablet || this.isDesktop
    },
    isDesktop () {
      return this.$resize && this.$mq.above(lg - 1)
    }
  }
}



// WEBPACK FOOTER //
// ./WebResources/vue/shared/mixins/responsive-breakpoints.js